import React, { Fragment, useMemo } from 'react';
import { translateService } from 'services/TranslateService';
import { useObservable } from 'react-use-observable';

interface IProps {
  term: string;
  properties?: { [key: string]: any };
  className?: string;
}

export const Translate: React.FC<IProps> = React.memo(props => {
  const [value] = useObservable(() => translateService.getTextStream(props.term), [props.term]);

  const result = useMemo(() => {
    const properties = props.properties || {};

    const parts: any[] = (value || '').split(/(\{[^}]+})/gi);

    const propertyMap = Object.keys(properties).reduce((acc, key) => {
      acc[`{${key}}`] = properties[key];
      return acc;
    }, {});

    parts.forEach((word, index) => {
      propertyMap[word]
        ? (parts[index] = (
          <span className={props.className} key={index}>
            {propertyMap[word]}
          </span>
        ))
        : (parts[index] = (
          <span className={props.className} key={index}>
            {word}
          </span>
        ));
    });

    return parts;
  }, [value, props.className, props.properties]);

  return <Fragment>{result}</Fragment>;
});

export default Translate;
